import CustomerPriceGroupsStore from '../store/CustomerPriceGroupsStore';

import { fetchFromJson } from './fetchFromJson';

const db = new CustomerPriceGroupsStore('customerPriceGroupsStore˝');
const updateCache = 'customersPriceGroup_updateCache';
const getUpdateCache = (data) => data.customer_price_groups;
const toast = 'Customers Price Group Updated';
const entityName = 'customerPriceGroups';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});
